import UserUpdate from "./UserUpdate";

export default UserUpdate;